<style lang="scss" scoped>
.csv-grid {
    & ::v-deep .el-select {
        width: 100%;
    }
    &__container {
        @include container;
    }
    &__panel {
        @include main-panel;
    }
    &__header {
        @include flex-center;
        &__options {
            margin-left: auto;
        }
        &__buttons {
            margin-left: auto;
            font-size: 14px;
            > span {
                margin-right: 10px;
            }
        }
    }
    &__footer {
        @include main-panel-footer;
        &__right {
            margin-left: auto;
        }
    }
    &__warning {
        color: red;
        font-size: 20px;
        padding-top: 7px;
    }
    &__header {
        @include flex-center;
        &__buttons {
            margin-left: auto;
            font-size: 14px;
            > div {
                margin-left: 15px;
            }
        }
    }
    &__table-wrapper {
        width: auto;
    }
    &__scrollable {
        overflow-x: auto;
        width: 1270px;
    }
    &__filtered {
        text-decoration: line-through;
        color: #C0C0C0;
    }
    &__original {
        text-decoration: line-through;
        color: #C0C0C0;
    }
    &__generated {
        color: green;
    }
}
</style>
<template lang="pug">
div 
    .csv-grid
        .csv-grid__container
            .csv-grid__panel
                .csv-grid__scrollable
                    .csv-grid__table-wrapper
                        table.table
                            thead
                                tr
                                    th(v-for="(item, i) in headers", :key="i") {{ item }}
                            tbody
                                tr(v-for="(row, i) in paginated", :key="`row-${i}`")
                                    td(nowrap, v-for="(field, j) in headers", :key="`column-${j}`")
                                        span.csv-grid__filtered(v-if="row.filtered")  {{ row[field] }}
                                        span(v-else)
                                            span(v-if="row[`${field}_orig`] && row[`${field}_orig`] !== row[field]")
                                                span.csv-grid__filtered {{ row[`${field}_orig`] }}
                                                span.csv-grid__generated &nbsp; {{ row[field] }}
                                            span(v-else) {{ row[field] }}
                .csv-grid__footer(v-if="paginated.length")
                    .csv-grid__footer__left
                        el-pagination(background="", @size-change="handleSizeChange", layout="sizes, prev, pager, next", :current-page.sync="page", :page-size="per_page", :total="data.length", :page-sizes="pageSize")
                    .csv-grid__footer__right 
                        | Showing
                        strong &nbsp;{{ paginated.length }}
                        | &nbsp;out of a possible
                        strong &nbsp;{{ data.length }}
                        | &nbsp;results
                empty(v-if="!data.length && !isLoading && !csvError" message="No data available for this CSV. Please check your settings or contact support.")
                loading(v-if="isLoading" :message="loadingMessage")
                empty(v-if="csvError" message="There was an error generating the CSV. Please try again later or contact support")
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";

export default {
    components: {
    },
    props: {
        data: Array,
        isLoading: Boolean,
    },

    data() {
        return {
            per_page: 50,
            page: 1,
            loadingMessage: [
                "Loading CSV data... Please wait."
            ],
			csvError: false,
			timeoutHandle: null
        };
    },

    computed: {
        paginated() {
            const page = _.chunk(this.data, this.per_page)[this.page - 1];

            return page ? page : [];
        },

        headers() {
            if (!this.data.length) return [];
            
            return _.filter(Object.keys(_.first(this.data)), (header) => {
                return !header.includes("_orig");
            });
        },

        pageSize() {
            let arrayCounter = [];
            let counter = 50;

            while (counter < this.data.length) {
                arrayCounter.push(counter);
                counter *= 2;
            }
            arrayCounter.push(this.data.length);
            
            return arrayCounter;
        },

        maxPage() {
            return Math.ceil(this.data.length / this.per_page);
        }
    },

    methods: {
        handleSizeChange(val) {
            setTimeout(() => {
                this.per_page = val ? val : this.data.length;
                this.page = 1;
            }, 100);
        },
    },

    watch: {
        data() {
            this.page = this.page > this.maxPage ? 1 : this.page;
        },
		isLoading(newVal) {
			if (newVal) {
				this.timeoutHandle = setTimeout(() => {
					if (this.isLoading) {
						this.csvError = true;
						this.isLoading = false;
					}
				}, 30 * 60 * 1000);
			} else {
				clearTimeout(this.timeoutHandle);
			}
		}
    }
};
</script>
